import {
    FETCH_SERVICE_TYPES_ERROR,
    FETCH_SERVICE_TYPES_SUCCESS
} from "actions/types";

import getServiceType from "api/serviceTypeApi";

export const setServiceTypes = payload => ({
    type: FETCH_SERVICE_TYPES_SUCCESS,
    payload
});

export const setServiceTypesError = (payload) => ({
    type: FETCH_SERVICE_TYPES_ERROR,
    payload,
});

export const fetchServiceTypes = (reset) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_SERVICE_TYPES_SUCCESS,
            payload: []
        });
        return;
    }
    getServiceType()
        .then(response => {
            dispatch(setServiceTypes(response.data));
        })
        .catch(() => {
            dispatch(setServiceTypesError({
                type: FETCH_SERVICE_TYPES_ERROR,
                message: "Could not fetch service types."
            }));
        });
};
